import { declensionOfSymbol } from '@utils/helpers';
import { safeFormatDate } from '@utils/date';
import { REQUIRED_MESSAGES } from '@srm/ui/lib/requiredMessage';

/**
 * Тексты ошибок валидации полей документа.
 *
 * Должны 1:1 совпадать с тем, что сейчас формируется в
 * `components/molecules/formbuilder/controls/Field/Field.tsx`
 * (функция `fieldControlType` и `checkDate`), иначе сломается паритет
 * при переходе на resolver. Менять только синхронно с источником.
 */
export const VALIDATION_MESSAGES = {
    /** required-правило И validate.notWhitespaceOnly (одинаковый текст) */
    required: REQUIRED_MESSAGES.text,
    /** pattern-правило */
    patternMismatch: 'Неверный формат',
    /** minLength для строковых типов */
    minLength: (n: number): string => `Минимальная длина поля: ${n} ${declensionOfSymbol(n)}`,
    /**
     * maxLength для строковых типов. Для дефолта 255 (Text без max) результат
     * совпадает с литералом из Field.tsx: declensionOfSymbol(255) === 'символов'.
     */
    maxLength: (n: number): string => `Максимальная длина поля: ${n} ${declensionOfSymbol(n)}`,
    /** checkDate: значение больше максимума */
    maxDate: (boundary: Date, fmt: string): string => 'Максимальное значение: ' + safeFormatDate(boundary, fmt),
    /** checkDate: значение меньше минимума */
    minDate: (boundary: Date, fmt: string): string => 'Минимальное значение: ' + safeFormatDate(boundary, fmt),
    /** checkDate: выбран выходной по рабочему календарю */
    holiday: 'Выбран выходной день',
} as const;

/** Формат даты в сообщениях границ: Date — без времени, остальные — с HH:mm. */
export const DATE_MESSAGE_FORMAT = 'DD.MM.YYYY';
export const DATETIME_MESSAGE_FORMAT = 'DD.MM.YYYY HH:mm';
